import { formatNumber } from '../number/format';
import { getLanguage } from '../user/device-info';

var counterUp = function() {
    const lang = getLanguage();

    const init = function( to, parent ) {
        var dest = parent.querySelectorAll( '.count-number' );
        var animationDurationInMS = 800; // ms
        var maxSteps = 40;
        var intervalDurationInMS = animationDurationInMS / maxSteps;
        dest.forEach( function( el ) {
            var from = parseInt( el.dataset.from || 0 );
            var difference = to - from;
            var step = Math.ceil( difference / maxSteps );

            // if step is 0 then we can just terminate
            if ( step === 0 ) {
                el.dataset.from = to;
                el.innerText = formatNumber( to, lang );
                return;
            }

            var intervalFunc = window.setInterval( update, intervalDurationInMS );

            var current = from;

            function update() {
                current += step;
                if ( difference >= 0 && current >= to ) {
                    current = to;
                    window.clearInterval( intervalFunc );
                    el.dataset.from = to;
                } else if ( difference <= 0 && current <= to ) {
                    current = to;
                    window.clearInterval( intervalFunc );
                    el.dataset.from = to;
                }
                el.innerText = formatNumber( current, lang );
            }
        } );
    };

    return {
        init: function( to, parent ) {
            init( to, parent );
        },
    };
}();

function showResultNumsButton( to, parent ) {
    parent.querySelectorAll( '.count-number, .txt-see' ).forEach( function( el ) {
        el.classList.remove( 'd-none' );
    } );
    parent.querySelectorAll( '.txt-search' ).forEach( function( el ) {
        el.classList.add( 'd-none' );
    } );
    counterUp.init( to, parent );
}

export function doSearch( form, originalEvent ) {
    var url = new URL( window.location.origin + form.dataset.keepCountEndpoint );
    var formData = new FormData( form );

    var mapSpecificValues = [ 'map-area', 'search-this-area', 'draw-your-search' ];

    if ( mapSpecificValues.includes( formData.get( 'locationId' ) ) ) {
        formData.delete( 'locationId' );
        formData.delete( 'locationFreeText' );
    }

    if ( originalEvent && originalEvent.detail && originalEvent.detail.extraValues ) {
        Object.keys( originalEvent.detail.extraValues ).forEach( function( key ) {
            formData.set( key, originalEvent.detail.extraValues[ key ] );
        } );
    }

    return http( url, {
        method: 'POST',
        body: formData,
    } )
        .then( function( response ) {
            if ( !response.ok ) {
                throw new Error( 'failed getting search count' );
            }
            return response.json();
        } )
        .then( function( result ) {
            if ( !result.success ) {
                throw new Error( 'failed getting search count' );
            }
            showResultNumsButton( result.data, form );
        } );
}

export function keepCountOnForm( form, triggerNow ) {
    var tryDoSearch = function( event ) {
        if ( window.searchTriggered ) {
            return;
        }

        window.searchTriggered = true;

        window.setTimeout( function() {
            window.searchTriggered = false;
            doSearch( form, event );
        }, 500 );
    };

    form.addEventListener( 'change', function( event ) {
        var target = event.target;

        var ignore = (
            target &&
            target.dataset.triggerCountOnChange &&
            target.dataset.triggerCountOnChange === 'false'
        );

        if ( ignore ) {
            return;
        }

        tryDoSearch( event );
    } );

    form.querySelectorAll( 'input,select' ).forEach( function( el ) {
        if ( el.dataset.triggerCountOnChange && el.dataset.triggerCountOnChange === 'false' ) {
            return;
        }

        el.addEventListener( 'change', tryDoSearch );
    } );

    var typeahead = form.querySelector( 'input[name="locationFreeText"]' );

    if ( typeahead ) {
        typeahead.addEventListener( 'awesomplete-selectcomplete', tryDoSearch );
    }

    var categoryTypeahead = form.querySelector( 'input[name="categoryFreeText"]' );

    if ( categoryTypeahead ) {
        categoryTypeahead.addEventListener( 'awesomplete-selectcomplete', tryDoSearch );
    }

    if ( triggerNow ) {
        tryDoSearch();
    }
}

export default function initPropertySearch() {
}
